/**
 * Delegates sticky-bar option select changes to the main variant-picker radios.
 * The variant-picker's own change listener handles all downstream logic
 * (variant fetch, morph, events).
 */
document.addEventListener('change', (event) => {
  const select = event.target.closest('.sticky-atc-option__select');
  if (!select) return;

  const stickyBar = select.closest('sticky-add-to-cart');
  if (!stickyBar) return;

  const { productId } = stickyBar.dataset;
  const optionValueId = select.value;

  const variantPicker = document.querySelector(`variant-picker[data-product-id="${productId}"]`);
  if (!variantPicker) return;

  const radio = variantPicker.querySelector(`input[data-option-value-id="${optionValueId}"]`);
  if (radio) radio.click();
});
